import { useEffect, useRef } from 'react';
import useAuthentication from './useAuthentication';
import useSessionManager from './useSessionManager';

export default () => {
  const sessionManager = useSessionManager();
  const sessionManagerRef = useRef(sessionManager);
  const [isAuthenticated, isAuthorizing] = useAuthentication();

  useEffect(() => {
    sessionManagerRef.current = sessionManager;
  });

  useEffect(() => {
    const { current: currentSessionManager } = sessionManagerRef;

    if (!isAuthenticated && !isAuthorizing && currentSessionManager) {
      currentSessionManager.authorize();
    }
  }, [isAuthenticated, isAuthorizing]);
};
